













import { Component, Vue } from 'vue-property-decorator';
import Loading from '@/components/layout/Loading.vue';

@Component({
  components: {
    Loading,
  },
})
export default class App extends Vue {
  public beforeMount() {
    this.$store.dispatch('initUserInfo');
  }
}
